import React from 'react';

// Shown only if a screen still can't load after the automatic reload (see
// utils/lazyWithReload), so nobody is left looking at a blank page.
class LoadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error('[LoadErrorBoundary] A page failed to load:', error);
  }

  componentDidUpdate(prevProps) {
    // Moving to another page gives it a fresh try.
    if (this.state.failed && prevProps.resetKey !== this.props.resetKey) this.setState({ failed: false });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="flex flex-col items-center justify-center gap-3 px-4 py-24 text-center" role="alert">
        <p className="text-base font-medium text-gray-900">{this.props.message || "This page couldn't load."}</p>
        <p className="text-sm text-gray-600">Refresh to try again.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50"
        >
          Refresh
        </button>
      </div>
    );
  }
}

export default LoadErrorBoundary;
